let vnumber = 0;

export default {
    beforeCreate() {
        this.vnumber = 'vn' + vnumber.toString();
        vnumber += 1;
    },
};
